// // src/utils/feeUtils.js
export const CalculateFees = (feeType, total, products, feeDetails, transaction) => {
    let filteredFees = feeDetails?.filter((fee) => fee.fee_type === feeType && fee.fee_frequency === 'per_deal');
    let feeAmount = 0;

    if (filteredFees && filteredFees[0]) {
        switch (filteredFees[0].fee_method) {
            case 'sofr_margin':
                const sofrPercentage = transaction?.platformCharges?.sofr_rate + filteredFees[0].fee_value;
                feeAmount = (sofrPercentage / 100) * total;
                break;

            case 'percentage':
                const percentage = filteredFees[0].fee_value;
                feeAmount = (percentage / 100) * total;
                break;

            case 'lumpsum':
                feeAmount = filteredFees[0].fee_value;
                break;

            case 'per_mt':
                products.forEach((product) => {
                    feeAmount += product.volume * filteredFees[0].fee_value; // Use product.volume from values.products
                });
                break;

            default:
                feeAmount = 0;
                break;
        }
    }

    return feeAmount;
};

